// @flow @jsx h
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import { Component, h } from 'preact'
import { bem, toArray } from '@nrk/dh-utils'
import { ViewportIntersections, SerumLazyResponsivePicture } from '@nrk/dh-feature-components'

/* Types */
import type { EpisodeType } from '../../domain'

/* Styles */
import styles from './index.css'

type Props = {
  episoder: EpisodeType[],
  load: boolean
}

type State = {
  displayLeft: boolean,
  displayRight: boolean,
  loadContent: boolean[],
  visibleContent: boolean[]
}

type LinkProps = {
  active: boolean,
  url: string,
  className: string,
  children: any
}

function Link (props: LinkProps) {
  if (props.active) {
    return <a href={props.url} class={props.className}>
      {props.children}
    </a>
  } else {
    return <div class={props.className}>{props.children}</div>
  }
}

export class EpisidevelgerBlokk extends Component<Props, State> {
  // looping = false
  elm: any
  sweetScroll: any

  constructor () {
    super()
    this.state = {
      displayLeft: true,
      displayRight: true,
      loadContent: [],
      visibleContent: []
    }
  }

  componentDidMount () {
    if (!('scrollBehavior' in this.elm.style && this.elm.scrollTo)) {
      this.sweetScroll = require('../../../../lib/wrappers/sweetScrollWrapper')
        .getSweetScroll()
        .then(SweetScroll => new SweetScroll({ horizontal: true }, this.elm))
    }
    this.hideScrollbar()
    this.updateSizes()
    window.addEventListener('resize', this.updateSizes)

    this.scrollTo(this.elm.children[this.getStartIndex()])
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateSizes)
  }

  updateSizes = () => {
    /* Calculating width of spacers. Too complicated to do in css */
    const containerWidth = this.elm.offsetWidth
    const containerLeftHalf = containerWidth / 2
    const containerRightHalf = containerWidth / 2

    const firstImage = this.elm.children[1]
    const lastImage = this.elm.children[this.elm.children.length - 2]

    this.elm.style.setProperty('--ev-component-width', `${this.elm.offsetWidth}px`)
    this.elm.style.setProperty('--ev-left-spacer-width', `${containerLeftHalf - firstImage.offsetWidth / 2}px`)
    this.elm.style.setProperty('--ev-right-spacer-width', `${containerRightHalf - lastImage.offsetWidth / 2}px`)
  }

  hideScrollbar () {
    const barHeight = this.elm.offsetHeight - this.elm.clientHeight
    this.elm.style.marginBottom = `-${barHeight}px`
    this.elm.style.maxHeight = `calc(100% + ${barHeight}px)`
  }

  getStartIndex () {
    // Calculate width of left half of container, including scroll padding
    const containerWidth = this.elm.offsetWidth
    const containerLeftHalf = containerWidth / 2

    const firstImage = this.elm.children[1]
    const secondImage = this.elm.children[2]

    if (containerLeftHalf > firstImage.offsetWidth + secondImage.offsetWidth / 2) {
      // Container is wide enough to show first image, when second image is selected
      return 2
    } else {
      return 1
    }
  }

  scrollTo (image: HTMLElement, smooth: boolean = false) {
    const elementCenter = image.offsetLeft + image.offsetWidth / 2
    const containerWidth = this.elm.offsetWidth
    const left = elementCenter - containerWidth / 2
    if (this.sweetScroll) {
      this.sweetScroll.then(scroll => (scroll.to({ left })))
    } else {
      this.elm.scrollTo({ left, behavior: smooth ? 'smooth' : 'instant' })
    }
  }

  findActiveImage () {
    const containerWidth = this.elm.offsetWidth
    const scrollLeft = this.elm.scrollLeft
    const matching = toArray(this.elm.children).filter(image => {
      const leftOfCenter = image.offsetLeft < scrollLeft + containerWidth / 2
      const rightOfCenter = image.offsetLeft + image.offsetWidth > scrollLeft + containerWidth / 2
      return leftOfCenter && rightOfCenter
    })

    if (matching && matching.length > 0) {
      return matching[0]
    } else {
      return undefined
    }
  }

  setDisplayLeft (displayLeft: boolean) {
    if (displayLeft !== this.state.displayLeft) {
      this.setState({ displayLeft })
    }
  }

  setDisplayRight (displayRight: boolean) {
    if (displayRight !== this.state.displayRight) {
      this.setState({ displayRight })
    }
  }

  handleScrollLeft = () => {
    const activeImage = this.findActiveImage()
    if (activeImage && activeImage.previousSibling) {
      this.scrollTo(activeImage.previousSibling, true)
    }
  }

  handleScrollRight = () => {
    const activeImage = this.findActiveImage()
    if (activeImage && activeImage.nextSibling) {
      this.scrollTo(activeImage.nextSibling, true)
    }
  }

  handleImageChange = (intersections: any[]) => {
    const images = intersections.slice(1, intersections.length - 1)

    const visibleContent = images.map((i, idx) => {
      const current = images[idx].isIntersecting
      const next = images[idx + 1] && images[idx + 1].isIntersecting
      const prev = images[idx - 1] && images[idx - 1].isIntersecting
      return current || next || prev
    })

    this.setState({ visibleContent: visibleContent })

    const leftImage = images[0]
    const rightImage = images[images.length - 1]
    this.setDisplayLeft(leftImage.ratio < 0.95)
    this.setDisplayRight(rightImage.ratio < 0.95)
  }

  render () {
    const { episoder, load } = this.props
    const { displayLeft, displayRight, visibleContent } = this.state

    return (
      <div class={styles.episodevelger__container}>
        <div class={styles.episodevelger__titlecontainer}>
          <h2>Vitenskapen bak medaljen</h2>
        </div>
        <div class={styles.episodevelger__inner}>
          <ViewportIntersections
            className={styles.episodevelger}
            onChange={this.handleImageChange}
            root={'self'}
            threshold={[0, 0.05, 0.5, 0.95, 1]}
            ref={(intersectionsElm: any) => (this.elm = intersectionsElm.elm)}>
            <div class={styles.episodevelger__spacerLeft} />
            {
              episoder.map((episode, idx) => (
                <div
                  key={idx}
                  class={bem(styles.episodevelger__episodeWrapper, { visible: !!visibleContent[idx] })}>
                  <div class={bem(styles.episodevelger__episode, { unpublished: episode.published !== 'true' })}>
                    <Link
                      active={episode.published === 'true'}
                      className={styles.episodevelger__poster}
                      url={episode.url}>
                      <SerumLazyResponsivePicture
                        className={styles.episodevelger__image}
                        id={episode.polopolyId}
                        alt={''}
                        sizes={'300px'}
                        ratio={'3:4'}
                        quality={0.8}
                        load={load} />
                      {episode.published !== 'true' &&
                      <div className={styles.episodevelger__notpublised}>Kommer snart</div>}
                      <div class={styles.episodevelger__gradient} />
                      <div class={styles.episodevelger__text}>
                        <div class={styles.episodevelger__title}>
                          {episode.title}
                        </div>
                        <div class={styles.episodevelger__subtitle}>
                          {episode.subtitle}
                        </div>
                      </div>
                    </Link>
                    <div className={styles.episodevelger__strek} />
                  </div>
                </div>))
            }

            <div
              className={styles.episodevelger__spacerRight} />
          </ViewportIntersections>
          <button
            className={styles.episodevelger__left}
            onClick={this.handleScrollLeft}
            style={{ opacity: displayLeft ? 1 : 0 }}
            disabled={!displayLeft}
            aria-label='Rull til venstre'>
            <svg aria-hidden>
              <use xlinkHref='#nrk-chevron-left' />
            </svg>
          </button>
          <button
            className={styles.episodevelger__right}
            onClick={this.handleScrollRight}
            style={{ opacity: displayRight ? 1 : 0 }}
            disabled={!displayRight}
            aria-label='Rull til høyre'>
            <svg aria-hidden>
              <use xlinkHref='#nrk-chevron-right' />
            </svg>
          </button>
        </div>
      </div>
    )
  }
}
